module.exports = __webpack_public_path__ + "assets/a42f6a3b51b1afba00fbb0d596ae7788.png";